import { useRef } from 'react'
import { SActionBtn, SBack, SLowcodeList, SMessage, STableActions } from 'shj-components'
import { useSetState } from 'ahooks'
import AddorEditModal from './components/AddorEditModal'
import { config } from './config.tsx'
import { deleteCloseData, getDataCloseTree } from '@/services/customerServices.ts'
import { message, Switch } from 'antd'
import dayjs from "dayjs";

export default function PriceManage() {
  const [state, setState] = useSetState<any>({
    open: false,
    record: {},
    cateTreeList: [],
  })

  const listRef = useRef()

  //   右侧数据查询
  const fetchList = values => {
    const { ...rest } = values
    console.log(rest);
    rest.query.startTime = rest.query.startTime? dayjs(rest.query.startTime).format('YYYY-MM-DD'):'',
    rest.query.endTime = rest.query.endTime? dayjs(rest.query.endTime).format('YYYY-MM-DD') : ''
    return new Promise((resolve, reject) => {
      getDataCloseTree(rest.query)
        .then(res => {
          resolve({ records: res, total: res.length })
          setState({ cateTreeList: res })
        })
        .catch(reject)
    })
  }

  // 右侧表格事件：
  const onAdd = () => onEdit()

  const onEdit = (record = {}) => {
    setState({ open: true, record })
  }

  const handleCloseAddorEditModal = () => {
    setState({ open: false, record: {} })
  }

  const onDel = (id: string) => {
    SMessage.confirm({
      onOk: () => {
        return deleteCloseData(id).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  // 右侧表格配置
  const extensions = {
    request: { fetchList },
    events: { onAdd },
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return (
          <Switch
            checkedChildren="启用"
            unCheckedChildren="禁用"
            disabled
            checked={record.object.enabled}
          />
        )
      },
      actionRender(_, record: Record<string, any>) {
        const level = record.object?.cateIdPath?.split('>').length

        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record.object)}> 编辑 </SActionBtn>
            {level - 1 < 4 && (
              <SActionBtn onClick={() => onEdit({ parentId: record.id })}> 添加下级 </SActionBtn>
            )}
            {!record.object.initFlag && (
              <SActionBtn danger onClick={() => onDel(record.id)}>
                {' '}
                删除{' '}
              </SActionBtn>
            )}
          </STableActions>
        )
      },
    },
  }

  return (
    <div>
      <SLowcodeList
        ref={listRef}
        searchMode="group"
        config={config}
        {...extensions}
        tableType={'antd'}
      />
      <AddorEditModal fn={listRef.current?.reload} {...state} onClose={handleCloseAddorEditModal} />
    </div>
  )
}
